/** Exact match or a path prefix: `/team/workspaces/ws_1` is under `/team/workspaces`, `/alerts/edge` is not under `/alerts/ed`. */
export function isPathnameUnder(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}
